import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Col, Container, Modal, Row, Button } from 'react-bootstrap';
import MultiSelectDropdown from "../Controls/multiselectdropdown";
import Route from "./RoutingActions/Route";
import UnRoute from "./RoutingActions/UnRoute";
import APICom from '../../utils/helpers/APICom';
import PersistStorage from "../../utils/helpers/PersistStorage";
import { useDispatch } from "react-redux";
import { addLoginResponse } from "../../features/login/loginSlice";
import ModuleSecurity from '../../utils/helpers/ModuleSecurity.js';


let clusterComboData = [];

const BuildManifest = (props) => {
    
    const [clusterFilterMultiSelect, setrouteFilterMultiSelect] = useState({ options: [], DropdownMode: 'rS', styles: { width: "98%", marginLeft: "0px" }, selectedValues: [] });
    const [isCreateNew, setIsCreateNew] = useState(!props.addtoRoute);
    const [showRouteActionCreate, setRouteActionCreate] = useState(false);
    const [showUnRouteActionCreate, setUnRouteActionCreate] = useState(false);
    const [disableUnRouteButton, setDisableUnRouteButton] = useState(true);
    const [disableAllButtons, setdisableAllButtons] = useState(false);
    const [force_assign, setforce_assign] = useState(false);
    const { loginData } = useSelector((store) => store.login);
    const [selectedManifest, setselectedManifest] = useState(props.addTripRoute);
    const [NoOfGroup, setNoOfGroup] = useState(-1);
    const [routeAlertObj, setRouteAlertObj] = useState({ alertTitle: '', alertMsg: '' });
    const [showRouteAlert, setRouteAlert] = useState(false);
    //const [clusterComboData,setclusterComboData]=useState([]);
    const [TableHeaders, setTableHeaders] = useState(["Route","Locked","Block","UnLocked","Selected For Day"]);
    const [showTableCols, setShowTableCols] = useState(false);
    const [routeDisplay, setRouteDisplay] = useState({});
    const addSingleTripToRoute = useRef(props.addtoRoute);
    const routeRef = useRef(props.addTripRoute);
    const [BtnTitle, setBtnTitle] = useState(<p className="m-0">Show Routes</p>);
    const [SelectedRouteSettingID, setSelectedRouteSettingID] = useState(-1);
    const dispatch = useDispatch();
    
    useEffect(() => {
        try{
            let groupOptions = [];
            const set = new Set();
            let affID = (props.selectedAffiliates.includes(",") ? props.selectedAffiliates.split(",")[0]:props.selectedAffiliates);
            GetRouteDropDownData(props.selectedDate, affID);
            const distinctGroup = [...new Set(props.GridRowData
                .map(data => data.Group)
                .filter(Group => Group)
            )];
            setNoOfGroup(distinctGroup.length);
            if(addSingleTripToRoute.current)
            {
                setDisableUnRouteButton(true);
                setIsCreateNew(false);
            }
            else
            {
                if (props.GridRowData !== undefined) {
                    props.GridRowData.forEach((data) => {
                        if (data.Route !== "") {
                            setDisableUnRouteButton(false);
                        }
                    });
                }
            }  

            if(props.triggerUnRoute)
            {
                handleUnRouteActionCreate();
                props.setTriggerUnRoute(false);
            }

           
        }
        catch(err){console.log(err);}
        
    }, [props.triggerUnRoute]);

    useEffect(() => {
        routeRef.current = props.addTripRoute;
    }, [props.addTripRoute]);

      useEffect(() => {
        if(props.bCallFromActivateTrip==true && routeRef.current!="" && SelectedRouteSettingID !== -1 && SelectedRouteSettingID !==null){
          //  RouteSelectCallback(routeRef.current)
            // const selectedCluster = clusterComboData.find(data => data.vManifestNumber === props.addTripRoute);

            // // Retrieve SettingID from the found object
            // const SettingID = selectedCluster ? selectedCluster.iSettingID : null;

            // setSelectedRouteSettingID(SettingID)
            handleRouteActionCreate(true)
           // props.setManifestBuildDialog(false);
            //handleCloseBuildManifestDialog();
        }
    }, [props.bCallFromActivateTrip, routeRef.current, SelectedRouteSettingID]);

    // useEffect(() => {
    //     debugger;

    //     if (props.GridRowData.length = 1)
    //     {

    //         if (props.GridRowData[0].Route === '' && props.GridRowData[0].CallOutStatus === ''){
    //             setsingleUnroutedUnclustered(false)

    //         }

    //         else{
    //             setsingleUnroutedUnclustered(true)

    //         }
            

    //     }
        
    // }, );

    const handleCloseBuildManifestDialog = () => {
        if (props.showManifestBuildDialog) {
            props.setAddtoRoute(false);
            props.setGridRefreshPaused(false);
            props.setManifestBuildDialog(false);
        }
    }

    const handleCheckboxChange = (event) => {
        if (event.target.value === "AddNew") {
            setIsCreateNew(true);
            setselectedManifest("");
        }
        else {
            setIsCreateNew(false);
        }
    };
    const handleRouteAlertClose = () =>{
        setRouteAlert(false);
    }

    // const handleRouteSuggestionAction = () => {

    // }

    const handleRouteActionCreate = (force_assign_called = false) => {
        if(isCreateNew === false){
            if(selectedManifest !== ''){
                let affID = (props.selectedAffiliates.includes(",") ? props.selectedAffiliates.split(",")[0]:props.selectedAffiliates);
                PersistStorage.save("selectedDate", props.selectedDate, 999, false);
                PersistStorage.save("AffiliateID", affID, 999, false);
                PersistStorage.save("forceSelectedDate", props.selectedDate, 999, false);
                PersistStorage.save("forceManifestId",selectedManifest, 999, false);
                const newLoginData = {
                    ...loginData, // Spread the existing properties of loginData
                    BuildManifestDispatchID:true, // Update the specific field
                    };
                dispatch(addLoginResponse(newLoginData));

                if (force_assign_called){   
                    PersistStorage.save("ARBSelectedOption",'ForceScheduling', 999, false);
                }
                else{
                    PersistStorage.save("ARBSelectedOption",'BuildManifest', 999, false);

                }
                
                setforce_assign(force_assign_called);
                setRouteActionCreate(true);
                //setConfirmationModalObj();
            }
            else{
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Action', alertMsg: 'No Route is Selected!!!.' });
                setRouteAlert(true);
            }
        }
        else{
            //setConfirmationModalObj();
            setRouteActionCreate(true);
        }
    }

    const handleUnRouteActionCreate = () => {
        setUnRouteActionCreate(true);
    }

    const GetRouteDropDownData = async (date, aff) => {
        try{
            let iTransTypeValue = '0';
            let bCallingFrom = 'AddToRoute'
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAllTodaysRoutes?selected_date=" + date + "&affiliate_id=" + aff + "&iTransType=" + iTransTypeValue+ "&bCallingFrom=" + bCallingFrom,  "get", { "Content-Type": "application/json" }, null, null);
            //setclusterComboData(response.data)
            clusterComboData = response.data;

            let groupOptions = [];
            const set = new Set();
            clusterComboData = clusterComboData.filter(item => item?.vManifestNumber !== "");

            if(clusterComboData !== undefined && clusterComboData?.length !== 0) {
                clusterComboData?.forEach((data, index) => {
                  if (data?.vVirtualRoute && !set.has(data?.vVirtualRoute)) {
                    set.add(data?.vVirtualRoute);
                    let time_only = data?.dtRouteStartTime?.split("T")[1]
                    let hourAndMinute = time_only?.slice(0, 5);
                    groupOptions?.push({"label": 
                    <table className="w-auto" style={{height:"50px !important"}}>
                      <tbody>
                      <tr className="text-center text-nowrap">
                        <td style={{maxWidth: "70px", minWidth: "69px", width: "70px !important", fontSize: "x-small"}}
                            title={data?.vVirtualRoute} className="p-0 m-0 user-select-none overflow-hidden">
                          {data?.vVirtualRoute}
                        </td>
                        <td style={{maxWidth: "30px", minWidth: "29px", width: "30px", fontSize: "x-small"}}
                            className="p-0 m-0 px-1 mx-1 user-select-none">
                          {data?.iTotalNoOfTrip}
                        </td>
                        <td style={{maxWidth: "40px", minWidth: "39px", width: "40px", fontSize: "x-small"}}
                            title={data?.dtRouteStartTime} className="p-0 m-0 px-1 mx-1 user-select-none">
                          {hourAndMinute}
                        </td>
                        <td style={{maxWidth: "40px", minWidth: "39px", width: "40px", fontSize: "x-small"}}
                            title={data.iTotalDistMile} className="p-0 m-0 px-1 mx-1 user-select-none">
                          {data?.iTotalDistMile === "" || data?.iTotalDistMile === null ? "0" : data?.iTotalDistMile}
                        </td>
                        <td style={{maxWidth: "40px", minWidth: "39px", width: "40px", fontSize: "x-small"}}
                            title={data.iTotalRouteMin} className="p-0 m-0 px-1 mx-1 user-select-none">
                          {data?.iTotalRouteMin === "" || data?.iTotalRouteMin === null ? "0" : data?.iTotalRouteMin}
                        </td>
                        <td style={{maxWidth: "40px", minWidth: "39px", width: "40px", fontSize: "x-small"}}
                            title={data?.SelectedForTheDay} className="p-0 m-0 px-1 mx-1 user-select-none">
                          {data?.SelectedForTheDay}
                        </td>
                      </tr>
                      </tbody>
                    </table>,
                      "value": data.vManifestNumber
                    })
                  }
                });
              }

            if (groupOptions?.length > 0) {
                groupOptions = [{
                  "label":
                      <table className="w-auto" style={{height: "50px !important"}}>
                        <thead>
                        <tr className="text-center text-nowrap">
                          <th style={{width: "70px", fontSize: "small"}} className="px-2 user-select-none">
                            {"Route"}
                          </th>
                          <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none">
                            {"Trips"}
                          </th>
                          <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none">
                            {"ST"}
                          </th>
                          <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none">
                            {"Dist"}
                          </th>
                          <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none">
                            {"Miles"}
                          </th>
                          <th style={{width: "50px", fontSize: "small"}} className="px-1 user-select-none">
                            {"Day"}
                          </th>
                        </tr>
                        </thead>
                      </table>, "value": "info"
                }].concat(groupOptions);
              }
              setrouteFilterMultiSelect({...clusterFilterMultiSelect, options: groupOptions, selectedValues: groupOptions.length > 0 ? groupOptions[0].value :"" });
            if(addSingleTripToRoute.current && props.GridRowData.length === 1)
            {
                RouteSelectCallback(routeRef.current);
            }
            else if(addSingleTripToRoute.current && props.GridRowData.length > 1)
            {
                RouteSelectCallback(routeRef.current);
            }
        }
        catch(err){console.log(err);}
    };

    const RouteSelectCallback = (_val) => {
        setselectedManifest(_val);
        if (_val !== "") {
            const selectedCluster = clusterComboData.find(data => data.vManifestNumber === _val);

            // Retrieve SettingID from the found object
            const SettingID = selectedCluster ? selectedCluster.iSettingID : null;

            setSelectedRouteSettingID(SettingID)

            PersistStorage.save("ManifestNumber", _val, 999, false);
            setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClusterSelectObjectBy(_val) } });
        }
    }

    // const handleRouteTableDisplay = async(e)=>{
    //     if(e.target.textContent === "Show Routes")
    //     {
    //         setBtnTitle(<span role='status' aria-hidden='true' className='spinner-border spinner-border-sm'></span>);
    //         let affID = (props.selectedAffiliates.includes(",")?props.selectedAffiliates.split(",")[0]:props.selectedAffiliates);
    //         let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetManifestARBRestriction?selected_date=" + props.selectedDate + "&affiliate_ids=" + affID
    //             , "get", { "Content-Type": "application/json" }, null, null);
    //         if(response.data !== null && response.data.length > 0)
    //         {
    //             setRouteDisplay(response.data);
    //             setShowTableCols(true);
    //             setBtnTitle(<p className="m-0">Hide Routes</p>);
    //         }
    //         else
    //         {
    //             setBtnTitle(<p className="m-0">Show Routes</p>);
    //         }
            
    //     }
    //     else
    //     {
    //         setShowTableCols(false);
    //         setBtnTitle(<p className="m-0">Show Routes</p>);
    //     }
    // }

    function generateManifestNumber(date, routeNo) {
        const year = date?.slice(0, 4);
        const month = date?.slice(5, 7);
        const day = date?.slice(8, 10);

        const manifestNumber = `${year}${month}${day}${routeNo}`;
        return manifestNumber;
    }

    const GetClusterSelectObjectBy = (_vVal) => {
        try{
            let groupOptions = [];
            for (let ii = 0; ii < clusterComboData.length; ii++) {
                if (clusterComboData[ii].vManifestNumber === _vVal) {
                    groupOptions.push({ "label": clusterComboData[ii].vVirtualRoute, "value": clusterComboData[ii].vManifestNumber });
                    break;
                }
            }
            return groupOptions;
        }
        catch(err){console.log(err);}
    }

    return (
        <>
            <Modal show={props.showManifestBuildDialog ? 1 : 0} centered onHide={handleCloseBuildManifestDialog} size="lg"
                aria-labelledby="contained-modal-title-vcenter" animation={true} keyboard={true} backdrop="static">
                <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
                    <Modal.Title className='dispatch_action_dialog_title_color user-select-none' id="contained-modal-title-vcenter">
                        Route Actions
                    </Modal.Title>
                </Modal.Header>
                {props.GridRowData.length > 0 ? 
                    <>
                        <Modal.Body className="grid-example">
                            <Container>
                                <Row>
                                    <Col md={3} className="w-100">
                                        <span className="user-select-none">FOR TRIP : <b className="mx-2">{props.GridRowData.length > 1 ? props.GridRowData.length + " trips selected" : props.GridRowData[0]["ConfirmationNo"]}</b></span>
                                        <span className="firstRow text-nowrap user-select-none"> Number of Groups : <b className="mx-2">{NoOfGroup}</b></span>
                                    </Col>
                                </Row>
                                {/* <Row className="pt-2">
                                    <Col md={12} className="d-flex" >
                                        <label>Unique list of Mobility Attributes of Selected Trips: </label>
                                        <label id="lblMobilityAttributes" className="lblMobilityAttributes"></label>
                                    </Col>
                                </Row> */}
                                <Row className="pt-2">
                                    <Col xs={5} >
                                        <input type="radio" name="cluster_name" value="AddToExisting" onClick={handleCheckboxChange} readOnly checked={isCreateNew === false} />
                                        <label className="px-1 text-nowrap position-absolute user-select-none">Add to Existing Route</label>
                                    </Col>
                                    <Col xs={4} >
                                        <input type="radio" name="cluster_name" value="AddNew" onClick={handleCheckboxChange} readOnly checked={isCreateNew === true} />
                                        <label className="px-1 text-nowrap position-absolute user-select-none">Any Route</label>
                                        
                                    </Col>
                                {/*<Col xs={3} className="d-flex justify-content-center">
                                        <Button variant="dark" className="text-nowrap" onClick={handleRouteTableDisplay}>{BtnTitle}</Button>
                            </Col>*/}
                                </Row>
                                
                                {isCreateNew === true ? null : (
                                    <>
                                        <Row className="pt-2">
                                            <Col md={4} className="d-flex user-select-none">
                                                <label>Route #</label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={5} className="d-flex">
                                                <MultiSelectDropdown options={clusterFilterMultiSelect} showCheckbox={false} className="w-100" SelectionChangeCallback={RouteSelectCallback} />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                
                            </Container>
                        </Modal.Body>
                        <Modal.Footer>
                            {/* <Button variant="dark" value="ForceAssign" onClick={() => handleRouteSuggestionAction()} disabled={singleUnroutedUnclustered}>Route Suggestion</Button> */}
                            
                            {ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && (
                                <Button variant="dark" value="Build Route" onClick={() => handleRouteActionCreate(false)} disabled={disableAllButtons || props.bCallFromActivateTrip}>Build Route</Button>
                            )}
                            {ModuleSecurity.CheckModuleSecurityByTag("tag_d2_ForceAssign") && (
                                <Button variant="dark" value="ForceAssign" onClick={() => handleRouteActionCreate(true)} disabled={isCreateNew || props.bCallFromActivateTrip}>Force Assign</Button>
                            )}
                            {ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && (
                                <Button variant="dark" value="Un-Route" onClick={handleUnRouteActionCreate} disabled={disableUnRouteButton || disableAllButtons}>Un-Route</Button>
                            )}
                            {/*<Button variant="dark" title="Apply Routes Setting" onClick={handleApplyRoutesSetting} disabled={!showTableCols}>Apply</Button>*/}
                            <Button variant="dark" onClick={handleCloseBuildManifestDialog}>Close</Button>
                        </Modal.Footer>
                    </>
                :   
                    <>
                        <Modal.Body className="user-select-none fw-bold">{"Please select a trip first before routing/unrouting."}</Modal.Body>
                        <Modal.Footer>
                        
                            <Button variant="dark" onClick={handleCloseBuildManifestDialog}>OK</Button>
                        
                        </Modal.Footer>
                    </>
                }
            </Modal>

            {showRouteAlert && <Modal centered show={showRouteAlert} onHide={handleRouteAlertClose} >
                <Modal.Header closeButton>
                    <Modal.Title>{routeAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{routeAlertObj.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleRouteAlertClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}

            {showRouteActionCreate ? 
             <Route GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showRouteActionCreate={showRouteActionCreate} 
            setRouteActionCreate={setRouteActionCreate} disbaleButton={setdisableAllButtons} manifestNumber={isCreateNew ? "" : selectedManifest}
            setIsCreateNew= {isCreateNew} selectedDate={props.selectedDate} selectedAffiliates={props.selectedAffiliates} force_assign={force_assign} 
            SelectedRouteSettingID = {SelectedRouteSettingID}  
            bCallFromActivateTrip={ props.bCallFromActivateTrip!==undefined && props.bCallFromActivateTrip===true ?true:false}
            /> : ""}

            {showUnRouteActionCreate ? <UnRoute GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showUnRouteActionCreate={showUnRouteActionCreate} setUnRouteActionCreate={setUnRouteActionCreate} disbaleButton={setdisableAllButtons} selectedDate={props.selectedDate} selectedAffiliates={props.selectedAffiliates}
            bCallFromActivateTrip={ props.bCallFromActivateTrip!==undefined && props.bCallFromActivateTrip===true ?true:false}/> : ""}
        </>
    );
}

export default BuildManifest;